/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  computed,
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  HangarInventoriesList,
  HangarInventoriesParams,
  HangarInventory,
  HangarInventoryCreateInput,
  HangarInventoryUpdateInput,
  SchemaValidationErrorResponse,
  StandardError,
  ValidationError
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Create Hangar Inventory
 */
export const createHangarInventory = (
    hangarInventoryCreateInput: MaybeRefOrGetter<HangarInventoryCreateInput>,
 signal?: AbortSignal
) => {
      hangarInventoryCreateInput = toValue(hangarInventoryCreateInput);

      return axiosClient<HangarInventory>(
      {url: `/hangar/inventories`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: hangarInventoryCreateInput, signal
    },
      );
    }




export const getCreateHangarInventoryMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventory>>, TError,CreateHangarInventoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof createHangarInventory>>, TError,CreateHangarInventoryMutationVariables, TContext> => {

const mutationKey = ['createHangarInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createHangarInventory>>, CreateHangarInventoryMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createHangarInventory(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateHangarInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof createHangarInventory>>>
    export type CreateHangarInventoryMutationBody = HangarInventoryCreateInput
    export type CreateHangarInventoryMutationError = ErrorType<ValidationError | StandardError>
    export type CreateHangarInventoryMutationVariables = {data: HangarInventoryCreateInput}

    /**
 * @summary Create Hangar Inventory
 */
export const useCreateHangarInventory = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createHangarInventory>>, TError,CreateHangarInventoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof createHangarInventory>>,
        TError,
        CreateHangarInventoryMutationVariables,
        TContext
      > => {
      return useMutation(getCreateHangarInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Inventories List
 */
export const hangarInventories = (
    params?: MaybeRefOrGetter<HangarInventoriesParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<HangarInventoriesList>(
      {url: `/hangar/inventories`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarInventoriesQueryKey = (params?: MaybeRefOrGetter<HangarInventoriesParams>,) => {
    return [
    'hangar','inventories', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarInventoriesQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventories>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoriesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventories>>> = ({ signal }) => hangarInventories(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventories>>, TError, TData>
}

export type HangarInventoriesQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventories>>>
export type HangarInventoriesQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventories List
 */

export function useHangarInventories<TData = Awaited<ReturnType<typeof hangarInventories>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarInventoriesParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventories>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoriesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Delete Hangar Inventory
 */
export const destroyHangarInventory = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<void>(
      {url: `/hangar/inventories/${slug}`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarInventoryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventory>>, TError,DestroyHangarInventoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventory>>, TError,DestroyHangarInventoryMutationVariables, TContext> => {

const mutationKey = ['destroyHangarInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangarInventory>>, DestroyHangarInventoryMutationVariables> = (props) => {
          const {slug} = props ?? {};

          return  destroyHangarInventory(slug,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangarInventory>>>

    export type DestroyHangarInventoryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type DestroyHangarInventoryMutationVariables = {slug: string}

    /**
 * @summary Delete Hangar Inventory
 */
export const useDestroyHangarInventory = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangarInventory>>, TError,DestroyHangarInventoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangarInventory>>,
        TError,
        DestroyHangarInventoryMutationVariables,
        TContext
      > => {
      return useMutation(getDestroyHangarInventoryMutationOptions(options), queryClient);
    }
    /**
 * @summary Hangar Inventory
 */
export const hangarInventory = (
    slug: MaybeRefOrGetter<string>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);

      return axiosClient<HangarInventory>(
      {url: `/hangar/inventories/${slug}`, method: 'GET', signal
    },
      );
    }




export const getHangarInventoryQueryKey = (slug: MaybeRefOrGetter<string>,) => {
    return [
    'hangar','inventories',slug
    ] as const;
    }


export const getHangarInventoryQueryOptions = <TData = Awaited<ReturnType<typeof hangarInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventory>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarInventoryQueryKey(slug);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarInventory>>> = ({ signal }) => hangarInventory(slug, signal);





   return  { queryKey, queryFn, enabled: computed(() => toValue(slug) !== null && toValue(slug) !== undefined), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarInventory>>, TError, TData>
}

export type HangarInventoryQueryResult = NonNullable<Awaited<ReturnType<typeof hangarInventory>>>
export type HangarInventoryQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Hangar Inventory
 */

export function useHangarInventory<TData = Awaited<ReturnType<typeof hangarInventory>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 slug: MaybeRefOrGetter<string>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarInventory>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarInventoryQueryOptions(slug,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Update Hangar Inventory
 */
export const updateHangarInventory = (
    slug: MaybeRefOrGetter<string>,
    hangarInventoryUpdateInput: MaybeRefOrGetter<HangarInventoryUpdateInput>,
 signal?: AbortSignal
) => {
      slug = toValue(slug);
hangarInventoryUpdateInput = toValue(hangarInventoryUpdateInput);

      return axiosClient<HangarInventory>(
      {url: `/hangar/inventories/${slug}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: hangarInventoryUpdateInput, signal
    },
      );
    }




export const getUpdateHangarInventoryMutationOptions = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventory>>, TError,UpdateHangarInventoryMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventory>>, TError,UpdateHangarInventoryMutationVariables, TContext> => {

const mutationKey = ['updateHangarInventory'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateHangarInventory>>, UpdateHangarInventoryMutationVariables> = (props) => {
          const {slug,data} = props ?? {};

          return  updateHangarInventory(slug,data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateHangarInventoryMutationResult = NonNullable<Awaited<ReturnType<typeof updateHangarInventory>>>
    export type UpdateHangarInventoryMutationBody = HangarInventoryUpdateInput
    export type UpdateHangarInventoryMutationError = ErrorType<SchemaValidationErrorResponse | StandardError>
    export type UpdateHangarInventoryMutationVariables = {slug: string;data: HangarInventoryUpdateInput}

    /**
 * @summary Update Hangar Inventory
 */
export const useUpdateHangarInventory = <TError = ErrorType<SchemaValidationErrorResponse | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateHangarInventory>>, TError,UpdateHangarInventoryMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof updateHangarInventory>>,
        TError,
        UpdateHangarInventoryMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateHangarInventoryMutationOptions(options), queryClient);
    }
